/**
 * Created by wu on 2017/6/7.
 */
import SockJS from 'sockjs-client';

let _try_time = 0;
let sockJS;

/**
 * SockJS调用
 * @param dispatch
 * @param deviceType
 */
export const initialSockJS = (dispatch, deviceType) => {
  sockJS = new SockJS(
    '/sockjs/webSocketIMServer?zoneId=0&uniqueId=0&deviceType=webadmin&connectType=admin&roomId=0&clientIp=null'
  );

  sockJS.onopen = () => {
    window.console.log('-------- open --------');
    // 增加心跳
    setInterval(() => sockJS.send('p'), 1000 * 10);
  };

  sockJS.onmessage = evt => {
    window.console.log('-------- message --------');
    if (evt.data && evt.type === 'message') {
      try {
        dispatch({
          type: 'monitor/socketMessage',
          message: JSON.parse(evt.data)
        });
      } catch (e) {
        window.console.log('-------- message error --------');
      }
    }
  };

  sockJS.onerror = () => {
    window.console.log('-------- error --------');
    if (_try_time > 10) {
      resetTryTime(dispatch, deviceType);
      return;
    }
    setTimeout(() => {
      _try_time = _try_time + 1;
      initialSockJS(dispatch, deviceType);
    }, 10000);
  };

  sockJS.onclose = () => {
    window.console.log('-------- close--------');
    if (_try_time > 10) {
      resetTryTime(dispatch, deviceType);
      return;
    }
    setTimeout(() => {
      _try_time = _try_time + 1;
      initialSockJS(dispatch, deviceType);
    }, 10000);
  };
};

export const resetTryTime = (dispatch, deviceType) => {
  setTimeout(() => {
    _try_time = 0;
    initialSockJS(dispatch, deviceType);
  }, 10 * 60 * 10000);
};

export const closeSockJS = () => {
  if (sockJS) {
    sockJS.close();
  }
};

/**
 * webSocket调用
 */
let webSocket;

export const initialWebSocket = dispatch => {
  if (window.WebSocket && !webSocket) {
    let head = window.location.protocol === 'https:' ? 'wss' : 'ws';
    //websocket/signalmonitor/{zoneId区域ID}/{roomId会议室ID}/{roomName会议室名字}/{uniqueId设备唯一ID}/{deviceType设备类型 androidpad, ipad, webadmin}/{connectType连接类型boardApp, boardH5, admin}
    webSocket = new WebSocket(
      `${head}://192.168.0.193/websocket/signalmonitor/0/0/none/none/webadmin/admin/none`
    );

    webSocket.onopen = function() {
      window.console.log('-------- open --------');
      // 增加心跳
      setInterval(() => webSocket.send('p'), 1000 * 10);
    };

    webSocket.onmessage = function(evt) {
      window.console.log('-------- message --------');
      if (evt.data && evt.type === 'message') {
        try {
          dispatch({ type: 'socketMessage', message: JSON.parse(evt.data) });
        } catch (e) {
          window.console.log('-------- message error --------');
        }
      }
    };

    webSocket.onclose = function() {
      window.console.log('-------- close--------');
    };
  }
};

export const closeWebSocket = () => {
  if (webSocket) {
    webSocket.close();
    webSocket = null;
  }
};



// WEBPACK FOOTER //
// ./src/utils/sockutil.js